module.exports = __webpack_public_path__ + "assets/img/8efece016baaba258a6c2cb958f24ff4.png";